import React from "react";

export const BannerStarGroup = () => {
  return (
    <div className="site__banner-star-group">
      <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9903 13.7051C12.9154 13.7461 12.8539 13.8076 12.813 13.8825L10.8136 17.5381C10.5937 17.9403 10.016 17.9403 9.79603 17.5381L7.79671 13.8825C7.75577 13.8076 7.69423 13.7461 7.61938 13.7051L3.96376 11.7058C3.56156 11.4858 3.56156 10.9082 3.96376 10.6882L7.61938 8.6889C7.69423 8.64796 7.75577 8.58642 7.79671 8.51157L9.79603 4.85595C10.016 4.45375 10.5937 4.45375 10.8136 4.85595L12.813 8.51157C12.8539 8.58642 12.9154 8.64796 12.9903 8.6889L16.6459 10.6882C17.0481 10.9082 17.0481 11.4858 16.6459 11.7058L12.9903 13.7051Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1903 6.40653C20.1529 6.427 20.1221 6.45777 20.1016 6.49519L19.102 8.323C18.992 8.5241 18.7032 8.5241 18.5932 8.323L17.5935 6.49519C17.5731 6.45777 17.5423 6.427 17.5049 6.40653L15.677 5.40687C15.4759 5.29688 15.4759 5.00805 15.677 4.89807L17.5049 3.8984C17.5423 3.87794 17.5731 3.84716 17.5935 3.80974L18.5932 1.98193C18.7032 1.78083 18.992 1.78083 19.102 1.98193L20.1016 3.80974C20.1221 3.84716 20.1529 3.87794 20.1903 3.8984L22.0181 4.89807C22.2192 5.00805 22.2192 5.29688 22.0181 5.40687L20.1903 6.40653Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1903 18.4957C20.1529 18.5162 20.1221 18.5469 20.1016 18.5844L19.102 20.4122C18.992 20.6133 18.7032 20.6133 18.5932 20.4122L17.5935 18.5844C17.5731 18.5469 17.5423 18.5162 17.5049 18.4957L15.677 17.496C15.4759 17.3861 15.4759 17.0972 15.677 16.9872L17.5049 15.9876C17.5423 15.9671 17.5731 15.9363 17.5935 15.8989L18.5932 14.0711C18.7032 13.87 18.992 13.87 19.102 14.0711L20.1016 15.8989C20.1221 15.9363 20.1529 15.9671 20.1903 15.9876L22.0181 16.9872C22.2192 17.0972 22.2192 17.3861 22.0181 17.496L20.1903 18.4957Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default BannerStarGroup;
